export default __webpack_public_path__ + "static/media/image_wwm (1).13732398.png";